$('.share-link, .offer-share-copy').on('click', function(e) {
    e.preventDefault();
    var url = this.href;
    window.open(url,'name','width=600,height=400');
});
